import { type ComponentProps } from "react"
import { Actions } from "@/components/organisms/Actions"

type Props = Omit<ComponentProps<typeof Actions.Accept>, "type">

export function FormActionsAccept({ ...props }: Props) {
    return (
        <Actions.Accept
            type="submit"
            {...props}
        />
    )
}
